(() => {
  if (window.__tssCartReferralLoaded) return;
  window.__tssCartReferralLoaded = true;
  const save = async (select) => {
    const status = select.closest('[data-cart-referral]')?.querySelector('[data-cart-referral-status]');
    select.disabled = true;
    if (status) status.textContent = 'Saving…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({attributes:{'How did you hear about us?':select.value}})
      });
      if (!response.ok) throw new Error();
      document.querySelectorAll('[data-cart-referral-select]').forEach(other => { if (other !== select) other.value = select.value; });
      if (status) status.textContent = select.value ? 'Saved' : '';
    } catch (_error) { if (status) status.textContent = 'Could not save. Please try again.'; }
    finally { select.disabled = false; }
  };
  document.addEventListener('change', event => { if (event.target.matches('[data-cart-referral-select]')) save(event.target); });
})();
